import React from 'react';
import { useLocation } from 'react-router-dom';

import ChooseAccessoryFlow from '../../../../../choose-accessory-flow/choose-accessory-flow';
import ChoosePackageFlow from '../../../../../choose-package-flow/choose-package-flow';
import FitmentSearchTypeCta from '../../../../../fitment-search-type-cta/fitment-search-type-cta';
import { SearchButtonGroup } from '../../../../../search-button/search-button';

import {
  useFitment,
  useNavigateTo
} from '../../../../../../shared/hooks/hooks';

import {
  getEventUIType,
  trackAction
} from '../../../../../../shared/utils/analytics/analytics';

import { SEARCH_TYPES } from '../../../../../../shared/constants/search-types';

import './fitment-search-ctas.scss';

interface FitmentSearchCtasProps {
  onSearchTypeSelected: (searchType: string) => void;
  searchTypeToHide?: string;
  selectedSearchType?: string;
  shouldDisplayShopTiresModal?: boolean;
}

function FitmentSearchCtas(props: FitmentSearchCtasProps) {
  const {
    onSearchTypeSelected,
    searchTypeToHide,
    selectedSearchType,
    shouldDisplayShopTiresModal
  } = props;
  const { selectedFitment } = useFitment();
  const navigateTo = useNavigateTo();
  const location = useLocation();
  const uiElementType = getEventUIType(location);
  const hideTypeLowerCase = searchTypeToHide?.toLowerCase();

  let ctasToDisplay;
  switch (selectedSearchType) {
    case SEARCH_TYPES.ACCESSORIES:
      ctasToDisplay = <ChooseAccessoryFlow />;
      break;
    case SEARCH_TYPES.PACKAGE:
      ctasToDisplay = <ChoosePackageFlow />;
      break;
    default:
      ctasToDisplay = (
        <SearchButtonGroup>
          {hideTypeLowerCase !== SEARCH_TYPES.TIRES && (
            <FitmentSearchTypeCta
              onClick={
                shouldDisplayShopTiresModal
                  ? () => {
                      trackAction('shop_modal_products_select_tires');
                      navigateTo('#/fitment/shop-tires');
                    }
                  : () => {
                      trackAction('shop_page_products_select_tires');
                      onSearchTypeSelected(SEARCH_TYPES.TIRES);
                    }
              }
              rideHeightType={selectedFitment?.rideHeightType}
              searchType={SEARCH_TYPES.TIRES}
            />
          )}
          {hideTypeLowerCase !== SEARCH_TYPES.WHEELS && (
            <FitmentSearchTypeCta
              onClick={() => {
                trackAction(`shop_${uiElementType}_products_select_wheels`);
                onSearchTypeSelected(SEARCH_TYPES.WHEELS);
              }}
              searchType={SEARCH_TYPES.WHEELS}
            />
          )}
          {!hideTypeLowerCase?.startsWith(SEARCH_TYPES.PACKAGE) && (
            <FitmentSearchTypeCta
              onClick={() => {
                trackAction(`shop_${uiElementType}_products_select_packages`);

                onSearchTypeSelected(SEARCH_TYPES.PACKAGE);
              }}
              searchType={SEARCH_TYPES.PACKAGE}
            />
          )}
          {hideTypeLowerCase !== SEARCH_TYPES.ACCESSORIES && (
            <FitmentSearchTypeCta
              onClick={() => {
                trackAction(
                  `shop_${uiElementType}_products_select_accessories`
                );
                onSearchTypeSelected(SEARCH_TYPES.ACCESSORIES);
              }}
              searchType={SEARCH_TYPES.ACCESSORIES}
            />
          )}
        </SearchButtonGroup>
      );
  }
  return (
    <div className="fitment-search-ctas" styleName="shop-ctas-wrapper">
      {ctasToDisplay}
    </div>
  );
}

export default FitmentSearchCtas;
